module.exports = __webpack_public_path__ + "img/jawalb.e6e9f310.png";